<template>
<div class="card">
  <div class="card-header">
    <h4 class="card-title"><i class="ti-filter"></i>Filtros</h4>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-xs-12">
        <p>
          Tipos:
          <el-select
            multiple
            filterable
            class="select-primary el-select"
            size="large"
            v-model="filters.status"
            placeholder="Filtros de clientes"
            @change="emitChangeFilter()"
          >
            <el-option
              v-for="(option, index) in statusFilter.options"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="index"
            />
          </el-select>
        </p>
      </div>
      <div class="col-xs-12">
        <p>
          Bairro:
          <el-select
            multiple
            filterable
            class="select-primary el-select"
            size="large"
            v-model="filters.neighborhood"
            placeholder="Todos os bairros"
            @change="emitChangeFilter()"
          >
            <el-option
              v-for="(option, index) in neigborhoodOptions"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="index"
            />
          </el-select>
        </p>
      </div>
      <div class="col-xs-12">
        <p>
          Usuário:
          <el-select
            multiple
            filterable
            class="select-primary el-select"
            size="large"
            v-model="filters.users"
            placeholder="Todos os usuários"
            @change="emitChangeFilter()"
          >
            <el-option
              v-for="(option, index) in usersOptinos"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="index"
            />
          </el-select>
        </p>
        <p>
          <input
            type="checkbox"
            v-model="userActivate"
            @change="setShowInactivate(userActivate)"
          > Exibir usuários inativos?
        </p>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'survey-list-filters',

  props: ['tickets', 'customers'],

  data () {
    return {
      filters: {
        status: [],
        neighborhood: [],
        users: []
      },
      statusFilter: {
        options: [
          { label: 'Associados', value: 'associated' },
          { label: 'Não associados', value: 'notAssociated' },
          { label: 'Pesquisados', value: 'surveyed' },
          { label: 'Não pesquisados', value: 'notSurveyed' }
        ]
      },
      userActivate: this.showInactivate || false
    }
  },

  watch: {
    setShowInactivate () {
      this.$nextTick(() => {
        this.userActivate = this.setShowInactivate
      })
    }
  },

  computed: {
    ...mapGetters('users', {
      users: 'usersIdName',
      showInactivate: 'showInactivate'
    }),

    usersOptinos () {
      let options = []
      for (let index in this.users) {
        options.push({ label: this.users[index], value: index })
      }
      return options
    },

    neigborhoodOptions () {
      let neigh = this.tickets.filter(item => {
        return this.customers[item.customerId]
      }).map(item => {
        return this.customers[item.customerId].address.neighborhood.toUpperCase()
      }).reduce((accum, current, index) => {
        if (index === 0) {
          accum = {}
        }
        accum[current] = null
        return accum
      }, {})

      return Object.keys(neigh)
        .sort((a, b) => {
          return (a).localeCompare(b)
        }).map(item => {
          return { name: item, value: item }
        })
    }
  },

  methods: {
    ...mapActions('users', {
      setShowInactivate: 'setShowInactivate'
    }),
    emitChangeFilter () {
      this.$emit('changeFilter', this.filters)
    }
  },

  mounted () {
    this.setShowInactivate(false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyListFilters.vue